import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign cross-origin "Script error." events raised by third-party embeds
// (e.g. TradingView widgets). These carry no actionable info but would otherwise be
// surfaced by the dev runtime-error overlay. Data loads normally.
window.addEventListener(
  "error",
  (e) => {
    const msg = (e && e.message) || "";
    const src = (e && e.filename) || "";
    if (msg === "Script error." || src.includes("tradingview")) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
